let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hVJdX")).then(() => parcelRequire('lW5j9'));